import {
  MeterMeasurementType,
  ConsumerType,
  MeteringDirection,
  SiteSetupProcessDataMieterstromzuschlag_application_intent,
  VoltageLevel
} from "../../../types/api.types";
import urls from "../../../urls";
import { MIETERSTROMZUSCHLAG_FORM } from "../../../utils/constants";
import type { FormFieldData } from "../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { type SiteSetupProcessForForm } from "../SiteSetupAssistant.types";

export const SITE_SETUP_ASSISTANT_FORM = {
  name: {
    name: "name",
    type: "text",
    label: "Bezeichnung der Liegenschaft"
  },
  defaultPvPlantsMeasurementType: {
    name: "defaultPvPlantsMeasurementType",
    type: "select",
    label:
      "Auf welche Art messen die Stromzähler der PV-Anlage(n) die Erzeugung?",
    data: [
      {
        value: MeterMeasurementType.Single,
        label: "Lastgang"
      },
      {
        value: MeterMeasurementType.ArbitraryCumulative,
        label: "Zählerstände (selbst abgelesen)"
      },
      {
        value: MeterMeasurementType.NoMeter,
        label: "Kein Zähler vorhanden"
      }
    ]
  },
  siteAddress: {
    name: "siteAddress",
    type: "text",
    label: "Straße und Hausnummer"
  },
  siteZip: {
    name: "siteZip",
    type: "text",
    label: "Postleitzahl"
  },
  siteCity: {
    name: "siteCity",
    type: "text",
    label: "Ort"
  },
  allTenantAddressesAreSameAsSiteAddress: {
    name: "allTenantAddressesAreSameAsSiteAddress",
    type: "boolean",
    label:
      "Entspricht die Adresse des Mieters der Adresse der Liegenschaft (kann später im Detail bearbeitet werden)?"
  },
  allTenantsParticipatingInMieterstrom: {
    name: "allTenantsParticipatingInMieterstrom",
    type: "boolean",
    label:
      "Nehmen alle Mieter am Mieterstrommodell teil (kann später im Detail bearbeitet werden)?"
  },
  connectionVoltageLevel: {
    name: "connectionVoltageLevel",
    type: "select",
    label: "Spannungsebene",
    data: [
      { value: VoltageLevel.Low, label: "Niederspannung" },
      {
        value: VoltageLevel.MediumTransformation,
        label: "Umspannung zu Niederspannung"
      },
      { value: VoltageLevel.Medium, label: "Mittelspannung" },
      {
        value: VoltageLevel.HighTransformation,
        label: "Umspannung zu Mittelspannung"
      },
      { value: VoltageLevel.High, label: "Hochspannung" },
      {
        value: VoltageLevel.ExtraHighTransformation,
        label: "Umspannung zu Hochspannung"
      },
      { value: VoltageLevel.ExtraHigh, label: "Höchstspannung" }
    ]
  },
  connectionMeasurementType: {
    name: "connectionMeasurementType",
    type: "radio",
    label: "Art der Messung",
    choices: [
      {
        value: MeterMeasurementType.Single,
        label: "Lastgang"
      },
      {
        value: MeterMeasurementType.ArbitraryCumulative,
        label: "Zählerstände (selbst abgelesen)"
      },
      {
        value: MeterMeasurementType.NoMeter,
        label: "Kein physischer Zähler (z. B. virtueller Summenzähler)"
      }
    ]
  },
  connectionMeteringDirection: {
    name: "connectionMeteringDirection",
    type: "select",
    label: "Messrichtung",
    data: [
      {
        value: MeteringDirection.Erzeugung_Einspeisung,
        label: "Erzeugung/Einspeisung"
      },
      {
        value: MeteringDirection.Verbrauch_Entnahme,
        label: "Verbrauch/Entnahme"
      },
      {
        value: MeteringDirection.Vier_Quadranten_Zaehler,
        label: "Vier-Quadranten-Zähler"
      },
      {
        value: MeteringDirection.Zweirichtungszaehler,
        label: "Zweirichtungszähler"
      }
    ]
  },
  connectionMeteringServiceProvider: {
    name: "connectionMeteringServiceProvider",
    type: "async-select",
    label: "Messstellenbetreiber",
    placeholder: "Name oder Marktpartneridentifikationsnummer",
    dataUrl: urls.api.meteringServiceProviders()
  },
  gridOperator: {
    name: "gridOperator",
    type: "async-select",
    label: "Anschlussnetzbetreiber",
    placeholder: "Anschlussnetzbetreiber oder Postleitzahl",
    dataUrl: urls.api.gridOperators()
  },
  connectionLocationFeedin: {
    name: "connectionLocationFeedin",
    label: "Mess- oder Marktlokation Einspeisung",
    type: "text"
  },
  connectionLocationFeedout: {
    name: "connectionLocationFeedout",
    label: "Mess- oder Marktlokation Entnahme",
    type: "text"
  },
  siteHasBatteryStorage: {
    name: "siteHasBatteryStorage",
    type: "boolean",
    label: "Befindet sich ein Batteriespeicher in der Liegenschaft?"
  },
  isBatteryStorageMeasuredSeparately: {
    name: "isBatteryStorageMeasuredSeparately",
    type: "boolean",
    label: "Hat der Batteriespeicher einen separaten Zähler?"
  },
  consumerAmount: {
    name: "consumerAmount",
    type: "number",
    label: "Anzahl der Verbrauchsstellen",
    placeholder: "Anzahl eingeben",
    min: 1,
    max: 200
  },
  defaultConsumerType: {
    name: "defaultConsumerType",
    type: "radio",
    label:
      "Vornehmlicher Typ der Belieferten (kann später im Detail bearbeitet werden)",
    choices: [
      {
        value: ConsumerType.PrivateHousehold,
        label: "Privathaushalt(e)"
      },
      {
        value: ConsumerType.NonProducingIndustry,
        label: "Gewerbe"
      }
    ]
  },
  defaultConsumerMeasurementType: {
    name: "defaultConsumerMeasurementType",
    type: "radio",
    label:
      "Alle Verbraucher werden wie folgt gemessen (kann später im Detail bearbeitet werden)",
    choices: [
      {
        value: MeterMeasurementType.Single,
        label: "Lastgang"
      },
      {
        value: MeterMeasurementType.ArbitraryCumulative,
        label: "Zählerstände (selbst abgelesen)"
      },
      {
        value: MeterMeasurementType.NoMeter,
        label: "Kein Zähler vorhanden"
      }
    ]
  },
  mieterstromzuschlagApplicationIntent: {
    name: "mieterstromzuschlagApplicationIntent",
    type: "radio",
    label: MIETERSTROMZUSCHLAG_FORM.APPLICATION_INTENT_LABEL,
    helpText: MIETERSTROMZUSCHLAG_FORM.APPLICATION_INTENT_HELP_TEXT,
    description:
      "Die von Ihnen registrierten Anlagen kommen für den Mieterstromzuschlag für die Belieferung gewerblicher Kunden in Betracht.",
    stack: true,
    styles: {
      label: { marginBottom: "calc((-0.5) * var(--mantine-spacing-xs))" },
      description: { marginTop: 0, marginBottom: "var(--mantine-spacing-xs)" }
    },
    choices: [
      {
        value:
          SiteSetupProcessDataMieterstromzuschlag_application_intent.ApplyOrAlreadyApplied,
        label: MIETERSTROMZUSCHLAG_FORM.APPLY_OR_ALREADY_APPLIED_LABEL
      },
      {
        value:
          SiteSetupProcessDataMieterstromzuschlag_application_intent.DoNotApply,
        label: MIETERSTROMZUSCHLAG_FORM.DO_NOT_APPLY_LABEL
      }
    ]
  },
  mieterstromzuschlagApplicationDate: {
    name: "mieterstromzuschlagApplicationDate",
    type: "date",
    label: MIETERSTROMZUSCHLAG_FORM.APPLICATION_DATE_LABEL
  }
} as const satisfies FormFieldData<SiteSetupProcessForForm>;
